'use client'

import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'
import { Icons } from '@/components/ui/icons'

interface Capability {
  icon: React.ElementType
  label: string
  query: string
}

const CAPABILITIES: Capability[] = [
  { icon: Icons.helpCircle, label: 'What can you help me with?', query: 'What can you help me with?' },
  { icon: Icons.fileText, label: 'Show all non-compliant vendors', query: 'Which vendors are non-compliant and why?' },
  { icon: Icons.activity, label: 'Stockholding evaluation status', query: 'What is the evaluation status of Stockholding?' },
  { icon: Icons.brain, label: 'Datamatics evaluation status', query: 'What is the evaluation status of Datamatics?' },
  { icon: Icons.lightbulb, label: 'Evidence page numbers', query: 'Show me evidence page numbers for all technical criteria' },
  { icon: Icons.info, label: 'Explain this page', query: 'Explain this page to me' },
]

interface CapabilityBubblesProps {
  onSelect: (query: string) => void
}

export function CapabilityBubbles({ onSelect }: CapabilityBubblesProps) {
  return (
    <div className="flex flex-wrap justify-center gap-2 p-2">
      {CAPABILITIES.map((cap, i) => {
        const Icon = cap.icon
        return (
          <motion.button
            key={i}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.06, duration: 0.25, ease: 'easeOut' }}
            onClick={() => onSelect(cap.query)}
            className={cn(
              'flex items-center gap-2 px-3 py-2 rounded-full',
              'border border-border-default bg-background-subtle',
              'text-sm text-brand-navy',
              'shadow-soft',
              'transition-all duration-200',
              'hover:border-brand-cornflower/40 hover:bg-white hover:shadow-medium',
              'focus:outline-none focus:ring-2 focus:ring-brand-cornflower/50'
            )}
          >
            <Icon className="h-4 w-4 text-brand-purple" strokeWidth={1.5} />
            <span className="text-xs sm:text-sm font-medium">{cap.label}</span>
          </motion.button>
        )
      })}
    </div>
  )
}

